import { ContextMenuContent } from "./ContextMenuContent";
import { ContextMenuContentMobile } from "./ContextMenuContentMobile";
import { useIsMobile } from "react-migration/lib/theme/hooks/useIsMobile";
import { useContextMenuClose } from "./ContextMenuCloseContext";
import { ContextMenuAlignAlignment, ContextMenuProps, ContextMenuSideAlignment } from "./ContextMenu.types";

export { useContextMenuClose, ContextMenuAlignAlignment, ContextMenuSideAlignment };
export type { ContextMenuProps };

export const ContextMenu = ({
  menuItems,
  trigger,
  triggerClassName,
  triggerIconProps = { icon: "icon-lt-more-2-line", size: "lg", extraClasses: "text-neutral-800", cursor: "pointer" },
  triggerTestId,
  contentTestId,
  leadChildren,
  tailChildren,
  side = ContextMenuSideAlignment.BOTTOM,
  sideOffset = 5,
  align = ContextMenuAlignAlignment.END,
  alignOffset = 0,
  disabled = false,
  onOpenChange,
  noBorder = false,
}: ContextMenuProps) => {
  const isMobile = useIsMobile();

  return (
    <div data-testid="context-menu">
      {leadChildren}
      {isMobile ? (
        <ContextMenuContentMobile
          menuItems={menuItems}
          trigger={trigger}
          triggerClassName={triggerClassName}
          triggerIconProps={triggerIconProps}
          triggerTestId={triggerTestId}
          contentTestId={contentTestId}
          side={side}
          sideOffset={sideOffset}
          align={align}
          alignOffset={alignOffset}
          disabled={disabled}
          onOpenChange={onOpenChange}
          noBorder={noBorder}
        />
      ) : (
        <ContextMenuContent
          menuItems={menuItems}
          trigger={trigger}
          triggerClassName={triggerClassName}
          triggerIconProps={triggerIconProps}
          triggerTestId={triggerTestId}
          contentTestId={contentTestId}
          side={side}
          sideOffset={sideOffset}
          align={align}
          alignOffset={alignOffset}
          disabled={disabled}
          onOpenChange={onOpenChange}
          noBorder={noBorder}
        />
      )}
      {tailChildren}
    </div>
  );
};
